import { Typography } from '@mui/material';
import {
  CustomFieldSchema,
  Dropdown,
  FieldProps,
  FieldWrapper,
  FormOption,
  RadioGroup
} from 'common/form';
import { TeamCheckboxGroup } from 'modules/candidate-profile/forms/components/TeamCheckboxGroup';
import { teamPickerFieldSx } from 'modules/candidate-profile/styles/teamPickerFieldSx';

// From this many teams the picker becomes a searchable menu.
const SEARCHABLE_FROM = 6;

type TeamPickerFieldProps = FieldProps<CustomFieldSchema> & {
  options: FormOption[];
  isSingleTeam: boolean;
  isReadOnly: boolean;
};

export const TeamPickerField: React.FC<TeamPickerFieldProps> = ({
  name,
  field,
  value,
  errorMessage,
  onChange,
  options,
  isSingleTeam,
  isReadOnly
}) => {
  const teamIds: string[] = value ?? [];
  const label = field.label as string;

  if (isReadOnly) {
    const names = options
      .filter((option) => teamIds.includes(option.value))
      .map((option) => option.label)
      .join(', ');
    return (
      <FieldWrapper label={label} subLabel="Managed by your admins">
        <Typography mt="10px">{names}</Typography>
      </FieldWrapper>
    );
  }

  if (options.length >= SEARCHABLE_FROM) {
    return (
      <Dropdown
        name={name}
        value={isSingleTeam ? teamIds[0] ?? '' : teamIds}
        errorMessage={errorMessage}
        onChange={(selected: string | string[]) =>
          onChange(Array.isArray(selected) ? selected : [selected])
        }
        field={{
          label,
          options,
          isSearchable: true,
          isMulti: !isSingleTeam,
          searchPlaceholder: 'Search for a team',
          buttonText: 'Select',
          popperSx: teamPickerFieldSx.popper
        }}
      />
    );
  }

  if (isSingleTeam) {
    return (
      <RadioGroup
        name={name}
        value={teamIds[0] ?? ''}
        errorMessage={errorMessage}
        onChange={(selected: string) => onChange([selected])}
        field={{ label, options }}
      />
    );
  }

  return (
    <TeamCheckboxGroup
      name={name}
      label={label}
      options={options}
      value={teamIds}
      errorMessage={errorMessage}
      onChange={onChange}
    />
  );
};
